export default __webpack_public_path__ + "static/media/jt_land.fa79ffbb.webp";